import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {FilterRecordsButton} from "../buttons/FilterRecordsButton.tsx";
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";

const useTools = () => {
    // Read-only module (FNP-536): no Add/Delete. Filter + Reload.
    const tools = [];

    tools.push(<FilterRecordsButton key='filter'/>);
    tools.push(<ReloadRecordsButton key='reload'/>);

    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Usage Events')}
            tools={useTools()}
        />
    );
};
